var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput } from '@/components/form/text-input.component';
import { useSalesforceService } from '@/hooks/use-salesforce-service.hook';
import { widgetActions } from '@/store';
import { useGetUserDetails } from '@/components/results-category/hooks/use-get-user-details.hook';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
export function FeedbackInput(_a) {
    var _b = _a.form, handleSubmit = _b.handleSubmit, reset = _b.reset, _c = _b.formState, errors = _c.errors, isSubmitSuccessful = _c.isSubmitSuccessful, control = _b.control;
    var userDetails = useGetUserDetails();
    var dispatch = useDispatch();
    var sendTestCompleted = useSalesforceService().sendTestCompleted;
    function submitFeedback() {
        sendTestCompleted().then(function () { return reset(); });
    }
    function handleOnChange(event) {
        dispatch(widgetActions.setUserDetails(__assign(__assign({}, userDetails), { feedback: event.target.value })));
    }
    return (_jsxs("div", __assign({ className: "space-y-5 md:space-y-8 md:row-start-1 md:row-end-3" }, { children: [_jsx(Typography, __assign({ className: "text-lg font-medium md:w-full block" }, { children: "Please share your feedback on your experience with the hearing test." })), _jsxs("form", __assign({ id: "feedback-form", onSubmit: handleSubmit(submitFeedback), className: "md:px-8 w-full h-full flex flex-col justify-center" }, { children: [_jsx(TextInput, { inputProps: {
                            onChange: handleOnChange,
                            className: 'rounded-xl hover:border-vivid-blue',
                        }, controlProps: {
                            name: 'feedback',
                            control: control,
                            rules: {
                                required: 'Feedback is required',
                                minLength: {
                                    value: 5,
                                    message: 'Feedback must be at least 5 characters',
                                },
                            },
                        }, multiline: true, rows: 6, placeholder: "Your message here", variant: "outlined", fullWidth: true, error: Boolean(errors.feedback), className: "max-w-xl rounded-xl shadow-[0px_2.672858715057373px_2.672858715057373px_0px_rgba(0,0,0,0.25)]", sx: {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '0.75rem',
                                borderColor: '#3264d8',
                            },
                            '& .MuiFormHelperText-root.Mui-error': {
                                color: '#FF0000',
                            },
                            '& .MuiOutlinedInput-notchedOutline.Mui-error ': {
                                borderColor: '#FF0000',
                            },
                            '& .MuiInputBase-input': {
                                md: {
                                    paddingX: '24px',
                                    paddingY: '26px',
                                },
                            },
                        } }), isSubmitSuccessful && (_jsx("p", __assign({ className: "mt-4 text-success" }, { children: "Feedback submitted successfully" })))] }))] })));
}
